<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.46195 13.8437C8.46195 12.8052 8.8081 11.6129 9.34657 10.6899C10.0004 9.53601 10.7312 9.07447 11.3081 8.22832C12.2696 6.80524 12.462 4.76678 11.8466 3.22832C11.2312 1.6514 9.76964 0.72832 8.07734 0.766781C6.38503 0.805243 5.00041 1.8437 4.46195 3.42063C3.84657 5.1514 4.1158 7.22832 5.50041 8.53601C6.07734 9.07447 6.6158 9.92063 6.3081 10.7283C6.03887 11.4976 5.1158 11.8437 4.46195 12.1514C2.96195 12.8052 1.15426 13.7283 0.846567 15.4975C0.538875 16.9591 1.53887 18.4591 3.1158 18.4591H9.65426C9.96195 18.4591 10.1543 18.0745 9.96195 17.8437C9.00041 16.7283 8.46195 15.3052 8.46195 13.8437Z"
          fill="currentColor"
        />
        <g opacity="0.8" clip-path="url(#clip0_3299_67095)">
          <path
            d="M17.6079 14.5042C17.6229 14.3788 17.6329 14.2485 17.6329 14.1131C17.6329 13.9777 17.6229 13.8473 17.6028 13.722L18.4503 13.0601C18.5255 12.9999 18.5455 12.8896 18.5004 12.8043L17.6981 11.4153C17.648 11.3251 17.5427 11.295 17.4524 11.3251L16.4545 11.7262C16.2439 11.5658 16.0233 11.4354 15.7776 11.3351L15.6272 10.2721C15.6121 10.1718 15.5269 10.1016 15.4266 10.1016H13.822C13.7217 10.1016 13.6415 10.1718 13.6264 10.2721L13.476 11.3351C13.2303 11.4354 13.0046 11.5708 12.799 11.7262L11.8012 11.3251C11.7109 11.29 11.6056 11.3251 11.5555 11.4153L10.7532 12.8043C10.703 12.8946 10.7231 12.9999 10.8033 13.0601L11.6507 13.722C11.6307 13.8473 11.6156 13.9827 11.6156 14.1131C11.6156 14.2435 11.6257 14.3788 11.6457 14.5042L10.7983 15.1661C10.7231 15.2263 10.703 15.3366 10.7482 15.4218L11.5505 16.8108C11.6006 16.9011 11.7059 16.9312 11.7962 16.9011L12.794 16.4999C13.0046 16.6604 13.2253 16.7908 13.471 16.8911L13.6214 17.9541C13.6415 18.0544 13.7217 18.1246 13.822 18.1246H15.4266C15.5269 18.1246 15.6121 18.0544 15.6222 17.9541L15.7726 16.8911C16.0183 16.7908 16.2439 16.6554 16.4495 16.4999L17.4474 16.9011C17.5377 16.9362 17.643 16.9011 17.6931 16.8108L18.4954 15.4218C18.5455 15.3316 18.5255 15.2263 18.4453 15.1661L17.6079 14.5042ZM14.6243 15.6174C13.7969 15.6174 13.12 14.9405 13.12 14.1131C13.12 13.2857 13.7969 12.6088 14.6243 12.6088C15.4517 12.6088 16.1286 13.2857 16.1286 14.1131C16.1286 14.9405 15.4517 15.6174 14.6243 15.6174Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_3299_67095">
            <rect width="9" height="9" fill="white" transform="translate(10.2002 9.5)" />
          </clipPath>
        </defs>
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
